<template>
  <input-base
    :name="name"
    :label="label"
    :errorMessage="errorMessage"
    :meta="meta"
  >
    <button
      v-for="opt in options"
      class="btn btn-sm"
      :key="opt.key"
      :class="buttonClass(opt)"
      @click="changeValue(opt.key)"
      type="button"
    >
      {{ opt.name }}
    </button>
  </input-base>
</template>

<script>
import { useField } from "vee-validate"
import InputBase from "@/components/layout/forms/Input.vue"

export default {
  components: {
    InputBase,
  },
  props: {
    modelValue: {
      type: [String, Boolean],
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {

    const {
      value: selectedKey,
      errorMessage,
      handleChange,
      meta,
    } = useField(props.name || props.label, undefined, {
      initialValue: props.modelValue,
    })


    function changeValue(val) {
      handleChange(val)
      emit('update:modelValue', val)
    }
    const buttonClass = function (opt) {
      if (opt.key == selectedKey.value) return { "btn-primary": true }
      else return {"btn-default": true}
    }

    return {
      buttonClass,
      changeValue,
      meta,
      errorMessage
    }
  },
}
</script>

<style scoped>
.btn {
  margin-right: 0.25em;
}
</style>
